export default __webpack_public_path__ + "static/media/Nivyavineeth.7e8cef9c.jpg";